import { render, staticRenderFns } from "./tasks-learn-more-dialog.vue?vue&type=template&id=1d280cde"
import script from "./tasks-learn-more-dialog.vue?vue&type=script&lang=js"
export * from "./tasks-learn-more-dialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports